<template>

    <div class="main">
      <professor v-if="$store.state.user.tipo == 2"></professor>
      <escola v-else></escola>
    </div>

</template>
<script>

import professor from '@/components/home/professor'
import escola from '@/components/home/escola'
import smed from '@/components/home/smed'

export default {
    data () {
      return {
        text: ''
      }
    },
    methods:{
        load(){  }
    },
    components:{ professor, escola, smed }
}
</script>
